"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceInsights = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/fp/sortBy"));
var sdk_model_1 = require("@gooddata/sdk-model");
var VisualizationClassConverter_1 = require("../../../convertors/fromBackend/VisualizationClassConverter");
var VisualizationConverter_1 = require("../../../convertors/fromBackend/VisualizationConverter");
var MetaConverter_1 = require("../../../convertors/fromBackend/MetaConverter");
var InsightConverter_1 = require("../../../convertors/toBackend/InsightConverter");
var api_1 = require("../../../utils/api");
var insightReferences_1 = require("./insightReferences");
var filterMerging_1 = require("./filterMerging");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var metadata_1 = require("../../../utils/metadata");
var BearWorkspaceInsights = /** @class */ (function () {
    function BearWorkspaceInsights(authCall, workspace) {
        var _this = this;
        this.authCall = authCall;
        this.workspace = workspace;
        this.getVisualizationClass = function (ref) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var uri, visClassResult;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.md.getObjects(_this.workspace, [uri]); })];
                    case 2:
                        visClassResult = _a.sent();
                        return [2 /*return*/, VisualizationClassConverter_1.convertVisualizationClass(visClassResult[0])];
                }
            });
        }); };
        this.getVisualizationClasses = function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var visualizationClassesResult, visClassOrderingIndex;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                                var queryOptions = {
                                    category: "visualizationClass",
                                };
                                if (options.includeDeprecated) {
                                    queryOptions.deprecated = true;
                                }
                                return sdk.md.getObjectsByQuery(_this.workspace, queryOptions);
                            })];
                        case 1:
                            visualizationClassesResult = _a.sent();
                            visClassOrderingIndex = function (visClass) { var _a; return (_a = visClass.visualizationClass.content.orderIndex) !== null && _a !== void 0 ? _a : 0; };
                            return [2 /*return*/, flow_1.default(sortBy_1.default(visClassOrderingIndex), map_1.default(VisualizationClassConverter_1.convertVisualizationClass))(visualizationClassesResult)];
                    }
                });
            });
        };
        this.getInsight = function (ref, options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var uri, visualization, userMap, _a, visClassResult, visClass, visualizationClassUri;
                var _this = this;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                        case 1:
                            uri = _b.sent();
                            return [4 /*yield*/, this.authCall(function (sdk) { return sdk.md.getVisualization(uri); })];
                        case 2:
                            visualization = _b.sent();
                            if (!options.loadUserData) return [3 /*break*/, 4];
                            return [4 /*yield*/, api_1.updateUserMap(new Map(), metadata_1.getVisualizationUserUris(visualization), this.authCall)];
                        case 3:
                            _a = _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            _a = undefined;
                            _b.label = 5;
                        case 5:
                            userMap = _a;
                            return [4 /*yield*/, this.authCall(function (sdk) {
                                    return sdk.md.getObjects(_this.workspace, [
                                        visualization.visualizationObject.content.visualizationClass.uri,
                                    ]);
                                })];
                        case 6:
                            visClassResult = _b.sent();
                            visClass = visClassResult[0];
                            visualizationClassUri = visClass.visualizationClass.content.url;
                            return [2 /*return*/, VisualizationConverter_1.convertVisualization(visualization, visualizationClassUri, userMap)];
                    }
                });
            });
        };
        this.getVisualizationClassesByVisualizationClassUri = function (options) {
            if (options === void 0) { options = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var visualizationClasses;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getVisualizationClasses(options)];
                        case 1:
                            visualizationClasses = _a.sent();
                            return [2 /*return*/, visualizationClasses.reduce(function (acc, el) {
                                    if (el.visualizationClass.uri) {
                                        acc[el.visualizationClass.uri] = el.visualizationClass.url;
                                    }
                                    return acc;
                                }, {})];
                    }
                });
            });
        };
        this.getInsights = function (options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var visualizationClassUrlByVisualizationClassUri;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVisualizationClassesByVisualizationClassUri({ includeDeprecated: true })];
                    case 1:
                        visualizationClassUrlByVisualizationClassUri = _a.sent();
                        return [2 /*return*/, this.getInsightsInner(options !== null && options !== void 0 ? options : {}, visualizationClassUrlByVisualizationClassUri, new Map())];
                }
            });
        }); };
        this.getInsightsInner = function (options, visualizationClassUrlByVisualizationClassUri, userMap) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var mergedOptions, defaultLimit;
            var _this = this;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                mergedOptions = tslib_1.__assign(tslib_1.__assign({}, options), { getTotalCount: true });
                defaultLimit = 50;
                return [2 /*return*/, sdk_backend_base_1.ServerPaging.for(function (_a) {
                        var limit = _a.limit, offset = _a.offset;
                        return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var data, items, totalCount, updatedUserMap, _b, insights;
                            var _this = this;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                                            return sdk.md.getObjectsByQueryWithPaging(_this.workspace, tslib_1.__assign(tslib_1.__assign({ category: "visualizationObject" }, mergedOptions), { 
                                                // the limit must be specified at all times, otherwise we get 400 (RAIL-3557)
                                                limit: limit,
                                                offset: offset }));
                                        })];
                                    case 1:
                                        data = _c.sent();
                                        items = data.items, totalCount = data.paging.totalCount;
                                        if (!options.loadUserData) return [3 /*break*/, 3];
                                        return [4 /*yield*/, api_1.updateUserMap(userMap, flatMap_1.default(items, metadata_1.getVisualizationUserUris), this.authCall)];
                                    case 2:
                                        _b = _c.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        _b = userMap;
                                        _c.label = 4;
                                    case 4:
                                        updatedUserMap = _b;
                                        insights = items.map(function (visualization) {
                                            return VisualizationConverter_1.convertVisualization(visualization, visualizationClassUrlByVisualizationClassUri[visualization.visualizationObject.content.visualizationClass.uri], updatedUserMap);
                                        });
                                        return [2 /*return*/, {
                                                items: insights,
                                                totalCount: totalCount,
                                            }];
                                }
                            });
                        });
                    }, (_a = mergedOptions.limit) !== null && _a !== void 0 ? _a : defaultLimit, mergedOptions.offset)];
            });
        }); };
        this.createInsight = function (insight) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var withConvertedVisClass, mdObject;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInsightWithConvertedVisClass(insight)];
                    case 1:
                        withConvertedVisClass = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.saveVisualization(_this.workspace, {
                                    visualizationObject: InsightConverter_1.convertInsightDefinition(withConvertedVisClass),
                                });
                            })];
                    case 2:
                        mdObject = _a.sent();
                        return [2 /*return*/, VisualizationConverter_1.convertVisualization(mdObject, sdk_model_1.insightVisualizationUrl(insight))];
                }
            });
        }); };
        this.updateInsight = function (insight) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var id, uri, withConvertedVisClass;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = sdk_model_1.insightId(insight);
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.md.getObjectUri(_this.workspace, id); })];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.getInsightWithConvertedVisClass(insight)];
                    case 2:
                        withConvertedVisClass = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.updateVisualization(_this.workspace, uri, {
                                    visualizationObject: InsightConverter_1.convertInsight(withConvertedVisClass),
                                });
                            })];
                    case 3:
                        _a.sent();
                        // sdk.md.updateVisualization returns just an URI, so we need to return the original insight
                        return [2 /*return*/, insight];
                }
            });
        }); };
        this.deleteInsight = function (ref) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var uri;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.md.deleteVisualization(uri); })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.openInsightAsReport = function (insight) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var visualizationObject;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                visualizationObject = InsightConverter_1.convertInsightDefinition(insight);
                return [2 /*return*/, this.authCall(function (sdk) {
                        return sdk.md.openVisualizationAsReport(_this.workspace, { visualizationObject: visualizationObject });
                    })];
            });
        }); };
        this.getInsightReferencedObjects = function (insight, types) {
            if (types === void 0) { types = ["dataSet", "measure", "fact", "attribute"]; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, new insightReferences_1.InsightReferencesQuery(this.authCall, this.workspace, insight, types).run()];
                });
            });
        };
        this.getInsightReferencingObjects = function (ref) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var uri, objectId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        objectId = api_1.getObjectIdFromUri(uri);
                        return [2 /*return*/, this.authCall(function (sdk) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var usedBy;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, sdk.xhr.getParsed("/gdc/md/" + this.workspace + "/usedby2/" + objectId + "?types=analyticalDashboard")];
                                        case 1:
                                            usedBy = _a.sent();
                                            return [2 /*return*/, {
                                                    analyticalDashboards: usedBy.entries.map(function (entry) {
                                                        return MetaConverter_1.convertMetadataObjectXrefEntry("analyticalDashboard", entry);
                                                    }),
                                                }];
                                    }
                                });
                            }); })];
                }
            });
        }); };
        this.getInsightWithAddedFilters = function (insight, filters) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var mergedFilters;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!filters.length) {
                            return [2 /*return*/, insight];
                        }
                        return [4 /*yield*/, filterMerging_1.appendFilters(sdk_model_1.insightFilters(insight), filters, function (refs) {
                                return api_1.objRefsToUris(refs, _this.workspace, _this.authCall);
                            })];
                    case 1:
                        mergedFilters = _a.sent();
                        return [2 /*return*/, sdk_model_1.insightSetFilters(insight, mergedFilters)];
                }
            });
        }); };
        this.getVisualizationClassByUrl = function (url) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var allVisClasses;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVisualizationClasses()];
                    case 1:
                        allVisClasses = _a.sent();
                        return [2 /*return*/, allVisClasses.find(function (visClass) { return visClass.visualizationClass.url === url; })];
                }
            });
        }); };
    }
    BearWorkspaceInsights.prototype.getInsightWithConvertedVisClass = function (insight) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var visClassUrl, visClass;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        visClassUrl = sdk_model_1.insightVisualizationUrl(insight);
                        return [4 /*yield*/, this.getVisualizationClassByUrl(visClassUrl)];
                    case 1:
                        visClass = _a.sent();
                        if (!visClass) {
                            throw new Error("Visualization class with url " + visClassUrl + " not found.");
                        }
                        return [2 /*return*/, {
                                insight: tslib_1.__assign(tslib_1.__assign({}, insight.insight), { visualizationUrl: visClass.visualizationClass.uri }),
                            }];
                }
            });
        });
    };
    return BearWorkspaceInsights;
}());
exports.BearWorkspaceInsights = BearWorkspaceInsights;
//# sourceMappingURL=index.js.map